const MODULE_URL = 'filesystem';
export default {
  MODULE_URL: MODULE_URL,
  LIST_URL: MODULE_URL + '/list_items',
  DIRECTORY_URL: MODULE_URL + '/directory',
  DISK_INFO_URL: MODULE_URL + '/disk_info',

  LOCATION_DOWNLOAD: 'download',
  LOCATION_GENERIC: 'settings',
};
